import { useMemo } from "react";
import { MaintenanceForwardingsDirectiveEntryKlass } from "../../features/forwardings/types/maintenanceForwardingsDirectiveEntryKlasses.type";
import { useForwardingTabContext } from "./useForwardingTabContext";
import { MaintenanceDirectiveObjectiveData } from "../../features/forwardings/types/forwardings/directiveEntries/directiveEntry.type";

const useGetDirectiveEntryObjectivesSummary = () => {
  const { forwarding, forwardingUpdatedAt, directiveEntryKlass } = useForwardingTabContext();

  return useMemo(() => {
    let piecesCount = 0;
    let activitiesCount = 0;

    let piecesKey: keyof MaintenanceDirectiveObjectiveData = 'diagnostic_pieces';
    let activitiesKey: keyof MaintenanceDirectiveObjectiveData = 'diagnostic_activities';

    if (directiveEntryKlass === MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry) {
      piecesKey = 'execution_pieces';
      activitiesKey = 'execution_activities';
    }

    const piecesTotalValue = forwarding?.directive_entry?.objectives?.reduce((prev, curr) => {
      return prev + (curr[piecesKey]?.reduce((prevB, currB) => {
        piecesCount += 1;

        return prevB + parseFloat(currB.total_value);
      }, 0) || 0);
    }, 0);

    const actitiviesTotalValue = forwarding?.directive_entry?.objectives?.reduce((prev, curr) => {
      return prev + (curr[activitiesKey]?.reduce((prevB, currB) => {
        activitiesCount += 1;

        return prevB + parseFloat(currB.total_value);
      }, 0) || 0);
    }, 0);

    let piecesCountDisplay: string;

    if (piecesCount === 0) piecesCountDisplay = 'Nenhuma peça'
    else if (piecesCount === 1) piecesCountDisplay = '1 Peça';
    else piecesCountDisplay = `${piecesCount} Peças`;

    let activitiesCountDisplay: string;

    if (activitiesCount === 0) activitiesCountDisplay = 'Nenhum serviço'
    else if (activitiesCount === 1) activitiesCountDisplay = '1 Serviço';
    else activitiesCountDisplay = `${activitiesCount} Serviços`;

    return {
      piecesCount,
      piecesCountDisplay,
      piecesTotalValue,
      activitiesCount,
      activitiesCountDisplay,
      actitiviesTotalValue,
    }
  }, [forwardingUpdatedAt]);
}

export default useGetDirectiveEntryObjectivesSummary;
